var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_5826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7145 20.9635C26.5027 16.1679 26.5027 8.39264 21.7145 3.597C16.9263 -1.19863 9.1632 -1.19864 4.37505 3.597C-0.41311 8.39264 -0.41311 16.1679 4.37505 20.9635C9.1632 25.7592 16.9263 25.7592 21.7145 20.9635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7503 16.9939C20.3096 14.4305 20.3096 10.2745 17.7503 7.71117C15.1909 5.14782 11.0414 5.14782 8.48203 7.71117C5.92267 10.2745 5.92267 14.4305 8.48203 16.9939C11.0414 19.5573 15.1909 19.5573 17.7503 16.9939Z",
    stroke: "#123164",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0297 10.1685L15.3912 14.5368",
    stroke: "#123164",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0297 14.5366L15.3912 10.1683",
    stroke: "#123164",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_5826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5217,
    height: 24.56,
    fill: "white",
    transform: "translate(0.783447)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.a8b5eebf1fe95dc684e8a43404dd6cb7.svg";
export { ForwardRef as ReactComponent };